<app-banner-internal *ngIf="dataCertifications" [title]="dataCertifications.page_title"></app-banner-internal>
<app-trust-banner *ngIf="dataCertifications" [card]="dataCertifications"></app-trust-banner>
<app-tabs type="images" *ngIf="dataCertifications">
    <app-tab *ngFor="let tab of dataTabs;index as i" [tabTitle]="lang == 'es' ? tab.name_es : tab.name" [active]="true">
        <app-certification-list [items]="dataDocuments" [buttonLabel]="dataCertifications"></app-certification-list>
    </app-tab>
</app-tabs>
